import styled from "styled-components";

// TEXT

// STYLES
export const CellColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
